export const SIDE_COLLAPSED_KEY = "simon.layout.sideCollapsed";
export const CONVERSATION_WIDTH_KEY = "simon.layout.convWidth";
export const DOCK_FOLDED_KEY = "simon.dock.folded";
export const CONVERSATION_FOLDED_KEY_PREFIX = "simon.layout.convFolded.";

export function loadSideCollapsed(): boolean {
  return readStored(SIDE_COLLAPSED_KEY) !== "0";
}

export function persistSideCollapsed(collapsed: boolean): void {
  writeStored(SIDE_COLLAPSED_KEY, collapsed ? "1" : "0");
}

export function loadDockFolded(): boolean {
  return readStored(DOCK_FOLDED_KEY) === "1";
}

export function persistDockFolded(folded: boolean): void {
  writeStored(DOCK_FOLDED_KEY, folded ? "1" : "0");
}

export function loadConversationWidth(): number | null {
  const stored = Number(readStored(CONVERSATION_WIDTH_KEY));
  return Number.isFinite(stored) && stored >= 200 && stored <= 4000 ? Math.round(stored) : null;
}

export function persistConversationWidth(width: number | null): void {
  if (width === null) removeStored(CONVERSATION_WIDTH_KEY);
  else writeStored(CONVERSATION_WIDTH_KEY, String(Math.round(width)));
}

export function loadConversationFolded(view: string): boolean | null {
  const stored = readSession(conversationFoldedKey(view));
  return stored === "1" ? true : stored === "0" ? false : null;
}

export function persistConversationFolded(view: string, folded: boolean): void {
  try {
    window.sessionStorage.setItem(conversationFoldedKey(view), folded ? "1" : "0");
  } catch {}
}

function conversationFoldedKey(view: string): string {
  return `${CONVERSATION_FOLDED_KEY_PREFIX}${view || "home"}`;
}

function readSession(key: string): string | null {
  try {
    return window.sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

function readStored(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function writeStored(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {}
}

function removeStored(key: string): void {
  try {
    window.localStorage.removeItem(key);
  } catch {}
}
